import { api } from '@/api';
import { api_routes } from '@/api-routes';

/**
 * Obtiene las categorías base con precios para una lista de abonados.
 * @param {number} listaId
 * @returns {Promise<AxiosResponse>}
 */
export function getCategorias(listaId) {
    return api.call(
        api_routes['back.bases.categorias.precios'],
        { lista_id: listaId },
    );
}

/**
 * Obtiene los equipos de una lista de abonados.
 * @param {number} listaId
 * @returns {Promise<AxiosResponse>}
 */
export function getEquipos(listaId) {
    return api.call(
        api_routes['back.bases.equipos.index'],
        { lista_id: listaId, filters: {} },
    );
}

/**
 * Guarda los datos personales del deportista (paso 1).
 * @param {object} payload — { lista_id, base: { ... }, fields_deportista }
 * @returns {Promise<AxiosResponse>}
 */
export function guardarDatos(payload) {
    return api.call(
        api_routes['back.bases.guardar-datos'],
        payload,
    );
}

/**
 * Guarda los datos de los responsables (paso 2).
 * @param {object} payload — { lista_id, session_id, responsable_1, responsable_2?, filters }
 * @returns {Promise<AxiosResponse>}
 */
export function guardarResponsables(payload) {
    return api.call(
        api_routes['back.bases.guardar-datos-responsables'],
        payload,
    );
}

/**
 * Guarda los documentos del deportista (paso 3).
 * @param {object} payload — { lista_id, session_id, documentos_id, foto_url, base?, filters }
 * @returns {Promise<AxiosResponse>}
 */
export function guardarDocumentos(payload) {
    return api.call(
        api_routes['back.bases.guardar-documentos'],
        payload,
    );
}

/**
 * Obtiene las indumentarias disponibles para una categoría base.
 * @param {object} params — { categoria_id, lista_id }
 * @returns {Promise<AxiosResponse>}
 */
export function getIndumentarias(params) {
    return api.call(
        api_routes['back.categorias.bases.indumentarias'],
        params,
    );
}

/**
 * Bloquea/reserva las indumentarias seleccionadas.
 * @param {object} payload — { indumentarias, session_id, filters }
 * @returns {Promise<AxiosResponse>}
 */
export function bloquearIndumentarias(payload) {
    return api.call(
        api_routes['front.bases.bloquear-indumentarias'],
        payload,
    );
}

/**
 * Guarda el descuento aplicado (paso 5).
 * @param {object} payload — { lista_id, session_id, descuento_aplicado, descuento_integro }
 * @returns {Promise<AxiosResponse>}
 */
export function guardarDescuentos(payload) {
    return api.call(
        api_routes['back.bases.guardar-descuentos'],
        payload,
    );
}

/**
 * Crea/finaliza la base del deportista (último paso).
 * @param {object} payload — { lista_id, session_id, metodo_pago, categoria_base_id }
 * @returns {Promise<AxiosResponse>}
 */
export function crearBase(payload) {
    return api.call(
        api_routes['back.bases.crear'],
        payload,
    );
}

/**
 * Actualiza campos de una base existente (ej: observaciones).
 * @param {object} payload — { lista_id, base_id, observaciones, filters }
 * @returns {Promise<AxiosResponse>}
 */
export function actualizarBase(payload) {
    return api.call(
        api_routes['back.bases.update'],
        payload,
    );
}

/**
 * Calcula los plazos para pago fraccionado.
 * @param {object} payload — { lista_id, session_id, categoria_id, frecuencia_id, n_plazos }
 * @returns {Promise<AxiosResponse>}
 */
export function calcularPlazos(payload) {
    return api.call(
        api_routes['back.bases.calcular-plazos'],
        payload,
    );
}

/**
 * Elimina los plazos calculados (vuelve a pago completo).
 * @param {object} payload — { lista_id, session_id, filters }
 * @returns {Promise<AxiosResponse>}
 */
export function borrarPlazos(payload) {
    return api.call(
        api_routes['back.bases.borrar-plazos'],
        payload,
    );
}
